import styles from './bootstrap-icons.scss?inline';

//Fix asset resolution for bootstrap-icons
//const fixedStyles = styles.replace('assets/fonts', 'dev/assets/fonts');
const fixedStyles = styles;

const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync( fixedStyles.toString() );

//Font-Face declarations need to be done at the document level
//or they will not be applied to the shadow DOM
if( !document.adoptedStyleSheets ) {
    document.adoptedStyleSheets = [];
}
document.adoptedStyleSheets.push( styleSheet );

export default styleSheet;